import React, { useEffect, useState } from 'react'
import { Tab } from "react-bootstrap";
import { SearchIcon, SearchIconWhite } from '../../../../assets/images';
import EmergencyContactForm from '../SiteConfig/EmergencyContactForm';
import { getCategoryIdlist, getEmergencyContactsBysite } from '../../../../services/configurationServices';

const TabEmergencyContact = ({isDarkTheme, selectedZone}) => {

    const [emergencyContact, setAllEmergencyContact] = useState([]); 
    const [categoryIdList, setCategoryIdList] = useState([]);
    const [mainEmergencyContact, setMainEmergencyContact] = useState([]);
    const [mainCategoryIdList, setMainCatagoryIdList] = useState([]);
    const [nameSearch, setNameSearch] = useState('');
    const [emailSearch, setEmailSearch] = useState('');
    const [contactSearch, SetContactSearch] = useState('');
    const [categorySearch, setCategorySearch] = useState('');
    const [contactLevelOptions, setContactLevelOptions] = useState([]);
    const [contaclLevelSearch, setContactLevelSearch] = useState('');
    const [noRecordsFound, setNoRecordsFound] = useState(false);

    useEffect(() => {
        getCategoryId()
    }, [])

    useEffect(() => {
        console.log("selectedZone", selectedZone)
        getEmergencyContact(selectedZone?.SiteID)
    }, [selectedZone])

    const getCategoryId = () => {
        try {
          let obj = {
            "type": "ContactCategory_Master",
            "parameters": {
              "UserId": localStorage.getItem('UserID')
            }
          }
          getCategoryIdlist(obj).then((resp) => {
            if (resp != undefined) {
              if (resp.Status == "success") {
                let arr = resp.Data
                if (arr == null) {
                  setCategoryIdList([])
                  setMainCatagoryIdList([])
                } else {
                  setCategoryIdList(arr)
                  setMainCatagoryIdList(arr)
                }
              } else {
                setCategoryIdList([])
                setMainCatagoryIdList([])
              }
            }
          })
        } catch (error) {
          console.error(error)
        }
      }

    const nameRegex = (event) => {
        const keyCode = event.keyCode || event.which;
        const keyValue = String.fromCharCode(keyCode);
        const isValid = new RegExp("^[A-Za-z0-9.\\-_ ]*$").test(keyValue);
        if (!isValid) {
            event.preventDefault();
            return;
        }
      };

      const emailRegex = (event) => {
        const keyCode = event.keyCode || event.which;
        const keyValue = String.fromCharCode(keyCode);
    
        const isValid = /[a-zA-Z0-9._%+-@]/.test(keyValue);
    
        if (!isValid) {
          event.preventDefault();
        }
      };

      const numberRegex = (event) => {
        const keyCode = event.keyCode || event.which;
        const keyValue = String.fromCharCode(keyCode);
        const isValid = new RegExp("[0-9]").test(keyValue);
        if (!isValid || event.target.value.length >= 10) {
            event.preventDefault();
            return;
        }
      };

      const searchNameList = (e) => {
        setNameSearch(e.target.value);
        let tempArr = mainEmergencyContact.filter(x => x.ContactName.toLowerCase().includes(e.target.value.toLowerCase()))
        setAllEmergencyContact(tempArr)
        // setNoRecordsFound(tempArr.length === 0);
    
      }
    
      const searchEmailList = (e) => {
        setEmailSearch(e.target.value);
        let tempArr = mainEmergencyContact.filter(x => x.EmailID.toLowerCase().includes(e.target.value.toLowerCase()))
        setAllEmergencyContact(tempArr)
        // setNoRecordsFound(tempArr.length === 0);
    
      }
    
      const searchContactList = (e) => {
        SetContactSearch(e.target.value);
        let tempArr = mainEmergencyContact.filter(x => x.Phone.toLowerCase().includes(e.target.value.toLowerCase()))
        setAllEmergencyContact(tempArr)
        // setNoRecordsFound(tempArr.length === 0);
      }
   
      const handleCategoryChange = (e) => {
        const selectedCategory = e.target.value;
        setCategorySearch(selectedCategory);
        
        if (selectedCategory === "") {
          setContactLevelSearch("");
          setAllEmergencyContact(mainEmergencyContact); 
          setContactLevelOptions([]);
        } else {
          const filteredContacts = mainEmergencyContact.filter(contact => contact.CategoryID.toString() === selectedCategory);
          setAllEmergencyContact(filteredContacts); 
          // setNoRecordsFound(filteredContacts.length === 0);
        }
        const selectedCategoryforLevel = categoryIdList?.find(cat => cat.CategoryID === parseInt(selectedCategory));
        if (selectedCategoryforLevel) {
          const levelLimit = selectedCategoryforLevel.LevelLimit;
          const newContactLevelOptions = Array.from({ length: levelLimit }, (_, index) => index + 1);
    
          setContactLevelOptions(newContactLevelOptions);
          setContactLevelSearch(newContactLevelOptions[0]); 
        }
      };

      const handleContactLevelChange = async (e) => {
        const newContactLevel = e.target.value;
        setContactLevelSearch(newContactLevel);
    
        // If newContactLevel is empty, show all contacts for the selected category
        if (newContactLevel === "" && categorySearch !== "") {
            // Filter contacts by category only
            const filteredContactsByCategory = mainEmergencyContact.filter(contact =>
                contact.CategoryID.toString() === categorySearch
            );
            setAllEmergencyContact(filteredContactsByCategory);
            // setNoRecordsFound(filteredContactsByCategory.length === 0);
        } else if (newContactLevel !== "") {
            // If newContactLevel is not empty, filter by both category and level
            const filteredContactsByLevel = mainEmergencyContact.filter(contact =>
                contact.CategoryID.toString() === categorySearch && contact.ContactLevel === parseInt(newContactLevel)
            );
            setAllEmergencyContact(filteredContactsByLevel);
            // setNoRecordsFound(filteredContactsByLevel.length === 0);
        } else if (categorySearch === "" ) {
            // If both category and level are empty, show all contacts
            setAllEmergencyContact(mainEmergencyContact);
        }
      }

      const getEmergencyContact = (SiteID) => {
        try {
          getEmergencyContactsBysite(SiteID).then((resp) => {
            if (resp != undefined) {
              if(resp.Status == "success" && resp.Data != null){
                let arr = resp.Data;
                let obj =  {
                  "EmergencyContactID": 0,
                  "SiteID": SiteID,
                  "ContactName": "",
                  "Phone": "",
                  "SMS": null,
                  "Email": null,
                  "WhatsApp": null,
                  "CreatedOn": "",
                  "CreatedBy": null,
                  "ModifiedOn": "",
                  "ModifiedBy": null,
                  "EmailID": "",
                  "IsCall": null,
                  "InApp": null,
                  "SubscriptionArn": null,
                  "UserID": null,
                  "ContactLevel": 0,
                  "Designation": "",
                  "IsERT": null,
                  "IsCustomerSPOC": null,
                  "OrganizationMasterID": 0,
                  "CategoryID": 0,
                  "UpdatedateTime": ""
              }
                arr.push(obj)
                setAllEmergencyContact(arr) 
                setMainEmergencyContact(arr)
            
      
              }
              else if(resp.Status == "success" && resp.Data == null){          
                let arr = [];
                let obj =  {
                  "EmergencyContactID": 0,
                  "SiteID": SiteID,
                  "ContactName": "",
                  "Phone": "",
                  "SMS": null,
                  "Email": null,
                  "WhatsApp": null,
                  "CreatedOn": "",
                  "CreatedBy": null,
                  "ModifiedOn": "",
                  "ModifiedBy": null,
                  "EmailID": "",
                  "IsCall": null,
                  "InApp": null,
                  "SubscriptionArn": null,
                  "UserID": null,
                  "ContactLevel": 0,
                  "Designation": "",
                  "IsERT": null,
                  "IsCustomerSPOC": null,
                  "OrganizationMasterID": 0,
                  "CategoryID": null,
                  "UpdatedateTime": ""
              }
                arr.push(obj)
                setAllEmergencyContact(arr)
                setMainEmergencyContact(arr)
              }
            }
          })
        } catch (error) {
          console.error(error)
        }
      }

  return (
    <table className="table table-text-ext table-fixed report-table healthmonitoringTable" id="alert-activity-report">
        <thead className="ReportTableHeader ReportTableHeadReport">
            <tr>
                <th>
                    <p>Name</p>
                    <div className="SearchTextDiv StatusSearchText">
                        <input
                            className="SearchViewInput"
                            type="search"
                            value={nameSearch}
                            placeholder="Search"
                            onChange={(e) => searchNameList(e)}
                            onKeyPress={nameRegex}
                            style={{width:"88%"}} />
                        {
                            isDarkTheme ?
                                <img className="EyeIcon" alt="Search-icon" src={SearchIcon} /> :
                                <img className="EyeIcon" alt="Search-icon" src={SearchIconWhite} height="15"/>
                        }
                    </div>
                </th>
                <th>
                    <p>Email</p>
                    <div className="SearchTextDiv StatusSearchText">
                        <input
                            className="SearchViewInput"
                            type="search"
                            value={emailSearch}
                            placeholder="Search" style={{width:"88%"}}
                            onChange={(e) => searchEmailList(e)}
                            onKeyPress={emailRegex}
                            
                        />
                        {
                            isDarkTheme ?
                                <img className="EyeIcon" alt="Search-icon" src={SearchIcon} /> :
                                <img className="EyeIcon" alt="Search-icon" src={SearchIconWhite} height="15"/>
                        }
                    </div>
                </th>
                <th>
                    <p>Mobile No.</p>
                    <div className="SearchTextDiv StatusSearchText">
                        <input
                            className="SearchViewInput"
                            type="search"
                            value={contactSearch}
                            placeholder="Search" style={{width:"88%"}}
                            onChange={(e) => searchContactList(e)}
                            onKeyPress={numberRegex}
                        />
                        {
                            isDarkTheme ?
                                <img className="EyeIcon" alt="Search-icon" src={SearchIcon} /> :
                                <img className="EyeIcon" alt="Search-icon" src={SearchIconWhite} height="15"/>
                        }
                    </div>
                </th>
                <th>
                    <p>Category</p>
                    <div className="SearchTextDiv StatusSearchText">
                        
                        <select required  className="ArrowSelect HMTableSelect"
                          value={categorySearch} // Bind to selectedCategoryId
                          onChange={handleCategoryChange}
                        
                          >
                        <option key="0" disabled={false} value="">
                                - Select -
                            </option>
                            
                            {mainCategoryIdList &&
                              mainCategoryIdList.map((item) => (
                                <option value={item.CategoryID} key={item.CategoryID}>
                                  {item.CategoryName}</option>
                              ))}
                        </select>
                      
                    </div>
                </th>
                <th>
                    <p>Level</p>
                    <div className="SearchTextDiv StatusSearchText">
                        <select required  className="ArrowSelect HMTableSelect"
                          value={contaclLevelSearch}
                          onChange={handleContactLevelChange}
                          >
                            <option key="0" disabled={false} value="">
                                - Select -
                            </option>
                            
                            {contactLevelOptions.map((level) => (
                            <option value={level} key={level}>
                                          {level}
                            </option>
                            ))}

                        </select>
                    </div>
                </th>
                {/* <th style={{width:"135px"}}>
                    <p>Pause Notification</p>
                </th> */}
                <th style={{width:"100px"}}></th>
            </tr>
        </thead>
        <tbody style={{height:"calc(100vh - 430px)"}}>
            {emergencyContact.length == 0 ? (
            <tr>
              <td colSpan="6" style={{ textAlign: "center" }}>
                <p>No records found</p>
              </td>
            </tr>
            ) : (
                emergencyContact.map((item) => (
                    <EmergencyContactForm
                        key={item.EmergencyContactID}
                        item={item}
                        getEmergencyContact={getEmergencyContact}
                        categoryIdList={categoryIdList}
                    />
                  ))
              )}
          {/* <tr>
            <td>
                <div className="inputTypeLabelContainer">
                  <input className="inputType"
                    placeholder="Ex. Kumar Khan"
                    style={{fontSize:"14px"}}
                    
                  />
                </div>
            </td>
            <td>
                <div className="inputTypeLabelContainer">
                  <input className="inputType"
                    placeholder="Ex. kkhan@rmail.com"
                    style={{fontSize:"14px"}}
                  />
                </div>
            </td>
            <td>
                <div className="inputTypeLabelContainer">
                  <input className="inputType"
                    placeholder="Ex. 9898989898"
                    style={{fontSize:"14px"}}
                  />
                </div>
            </td>
            <td>
                <div className="inputTypeLabelContainer">
                  <input className="inputType"
                    placeholder="Ex. Development"
                    style={{fontSize:"14px"}}
                  />
                </div>
            </td>
            <td>
                <div className="inputTypeLabelContainer">
                  <select className="inputType ArrowSelectClass">
                    <option key="0" value="0" id="0">Select</option>                                           
                  </select>
                </div>
            </td>  
            <td style={{width:"135px"}}>
              <div style={{display:"flex", justifyContent:"center", alignItems:"center", height:"35px"}}>
                <input type="checkbox"/>
              </div>
            </td>
            <td style={{width:"100px"}}>
              <div style={{display:"flex", justifyContent:"space-between", height:"35px"}}>
                <button style={{background:"transparent"}}>
                    <img className="EyeIcon" alt="Search-icon" src={CheckRowBlue} /> 
                </button>
                <button style={{background:"transparent"}}>
                    <img className="EyeIcon" alt="Search-icon" src={CancelRowBlue} /> 
                </button>
              </div>
            </td>                              
          </tr>
          <tr>
            <td>
                <div className="inputTypeLabelContainer removeBorder">
                  <input className="inputType" readOnly 
                  value="kamal Khan"
                  />
                </div>
            </td>
            <td>
                <div className="inputTypeLabelContainer removeBorder">
                  <input className="inputType" readOnly
                    value="kkhan@rmail.com"
                  />
                </div>
            </td>
            <td>
                <div className="inputTypeLabelContainer removeBorder">
                  <input className="inputType" readOnly
                    value="9898989898"
                  />
                </div>
            </td>
            <td>
                <div className="inputTypeLabelContainer removeBorder">
                  <input className="inputType" readOnly
                    value="Development"
                  />
                </div>
            </td>
            <td>
                <div className="inputTypeLabelContainer removeBorder">
                  <p>01</p>
                </div>
            </td>  
            <td style={{width:"135px"}}>
              <div style={{display:"flex", justifyContent:"center", alignItems:"center", height:"35px"}}>
                <input type="checkbox"/>
              </div>
            </td>
            <td style={{width:"100px"}}>
              <div style={{display:"flex", justifyContent:"space-between", height:"35px"}}>
                <button style={{background:"transparent"}}>
                    <img className="EyeIcon" alt="Search-icon" src={EditRowBlue} /> 
                </button>
                <button style={{background:"transparent"}}>
                    <img className="EyeIcon" alt="Search-icon" src={DeleteRowBlue} /> 
                </button>
              </div>
            </td>                              
          </tr>
          <tr>
            <td>
                <div className="inputTypeLabelContainer">
                  <input className="inputType"
                    value="Kumar Khan"
                    style={{fontSize:"14px"}}
                  />
                </div>
            </td>
            <td>
                <div className="inputTypeLabelContainer">
                  <input className="inputType"
                    value="kkhan@rmail.com"
                    style={{fontSize:"14px"}}
                  />
                </div>
            </td>
            <td>
                <div className="inputTypeLabelContainer">
                  <input className="inputType"
                    value="9898989898"
                    style={{fontSize:"14px"}}
                  />
                </div>
            </td>
            <td>
                <div className="inputTypeLabelContainer">
                  <input className="inputType"
                    value="Development"
                    style={{fontSize:"14px"}}
                  />
                </div>
            </td>
            <td>
                <div className="inputTypeLabelContainer">
                  <select className="inputType ArrowSelectClass">
                    <option key="0" value="0" id="0">One</option>
                    <option key="0" value="0" id="0">Two</option> 
                    <option key="0" value="0" id="0">Three</option> 
                    <option key="0" value="0" id="0">Four</option>                                            
                  </select>
                </div>
            </td>  
            <td style={{width:"135px"}}>
              <div style={{display:"flex", justifyContent:"center", alignItems:"center", height:"35px"}}>
                <input type="checkbox"/>
              </div>
            </td>
            <td style={{width:"100px"}}>
              <div style={{display:"flex", justifyContent:"space-between", height:"35px"}}>
                <button style={{background:"transparent"}}>
                    <img className="EyeIcon" alt="Search-icon" src={CheckRowBlue} /> 
                </button>
                <button style={{background:"transparent"}}>
                    <img className="EyeIcon" alt="Search-icon" src={CancelRowBlue} /> 
                </button>
              </div>
            </td>                              
          </tr> */}
        </tbody>
    </table>
  )
}

export default TabEmergencyContact